import { useState, useRef, useMemo, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { ShoppingBag, Search, X, Menu, Heart, Settings2, ChevronDown } from "lucide-react";
import { BrupaLogo } from "@/components/BrupaLogo";
import { useCart } from "@/lib/cartContext";
import { useWishlist } from "@/lib/wishlistContext";
import { CartDrawer } from "@/components/CartDrawer";
import { products } from "@/data/products";
import { cn } from "@/lib/utils";

const megaMenuData = {
  donna: [
    {
      title: "Abbigliamento",
      href: "/donna",
      items: [
        { label: "Vestiti", href: "/donna?cat=abbigliamento&sub=vestiti" },
        { label: "Giacche", href: "/donna?cat=abbigliamento&sub=giacche" },
        { label: "Cappotti", href: "/donna?cat=abbigliamento&sub=cappotti" },
        { label: "Gonne", href: "/donna?cat=abbigliamento&sub=gonne" },
        { label: "Maglioni", href: "/donna?cat=abbigliamento&sub=maglioni" },
        { label: "Camicie & Bluse", href: "/donna?cat=abbigliamento&sub=camicie" },
        { label: "T-shirt & Top", href: "/donna?cat=abbigliamento&sub=top" },
        { label: "Pantaloni", href: "/donna?cat=abbigliamento&sub=pantaloni" },
        { label: "Jeans", href: "/donna?cat=abbigliamento&sub=jeans" },
        { label: "Felpe", href: "/donna?cat=abbigliamento&sub=felpe" },
      ],
    },
    {
      title: "Scarpe",
      href: "/donna?cat=scarpe",
      items: [
        { label: "Sneakers", href: "/donna?cat=scarpe&sub=sneakers" },
        { label: "Décolleté", href: "/donna?cat=scarpe&sub=decollete" },
        { label: "Sandali", href: "/donna?cat=scarpe&sub=sandali" },
        { label: "Stivali", href: "/donna?cat=scarpe&sub=stivali" },
        { label: "Ballerine", href: "/donna?cat=scarpe&sub=ballerine" },
        { label: "Mules", href: "/donna?cat=scarpe&sub=mules" },
      ],
    },
    {
      title: "Borse",
      href: "/donna?cat=borse",
      items: [
        { label: "Borse a mano", href: "/donna?cat=borse&sub=borse-a-mano" },
        { label: "Borse a tracolla", href: "/donna?cat=borse&sub=tracolla" },
        { label: "Clutch", href: "/donna?cat=borse&sub=clutch" },
        { label: "Zaini", href: "/donna?cat=borse&sub=zaini" },
        { label: "Shopper", href: "/donna?cat=borse&sub=shopper" },
      ],
    },
    {
      title: "Accessori",
      href: "/donna?cat=accessori",
      items: [
        { label: "Foulard", href: "/donna?cat=accessori&sub=foulard" },
        { label: "Cinture", href: "/donna?cat=accessori&sub=cinture" },
        { label: "Occhiali", href: "/donna?cat=accessori&sub=occhiali" },
        { label: "Gioielli", href: "/donna?cat=accessori&sub=gioielli" },
        { label: "Cappelli", href: "/donna?cat=accessori&sub=cappelli" },
        { label: "Sciarpe", href: "/donna?cat=accessori&sub=sciarpe" },
      ],
    },
    {
      title: "In evidenza",
      href: "/donna",
      items: [
        { label: "Nuovi arrivi", href: "/donna?view=ultimi-arrivi" },
        { label: "I più visti", href: "/donna?view=piu-visti" },
        { label: "Saldi", href: "/donna?view=piu-sconto" },
        { label: "Consigliati da Brupa", href: "/donna?view=consigliati" },
      ],
    },
  ],
  uomo: [
    {
      title: "Abbigliamento",
      href: "/uomo",
      items: [
        { label: "Completi", href: "/uomo?cat=abbigliamento&sub=completi" },
        { label: "Giacche", href: "/uomo?cat=abbigliamento&sub=giacche" },
        { label: "Cappotti", href: "/uomo?cat=abbigliamento&sub=cappotti" },
        { label: "Pantaloni", href: "/uomo?cat=abbigliamento&sub=pantaloni" },
        { label: "Polo", href: "/uomo?cat=abbigliamento&sub=polo" },
        { label: "Camicie", href: "/uomo?cat=abbigliamento&sub=camicie" },
        { label: "T-shirt", href: "/uomo?cat=abbigliamento&sub=tshirt" },
        { label: "Maglioni", href: "/uomo?cat=abbigliamento&sub=maglioni" },
        { label: "Jeans", href: "/uomo?cat=abbigliamento&sub=jeans" },
        { label: "Shorts", href: "/uomo?cat=abbigliamento&sub=shorts" },
      ],
    },
    {
      title: "Scarpe",
      href: "/uomo?cat=scarpe",
      items: [
        { label: "Sneakers", href: "/uomo?cat=scarpe&sub=sneakers" },
        { label: "Oxford", href: "/uomo?cat=scarpe&sub=oxford" },
        { label: "Stivali", href: "/uomo?cat=scarpe&sub=stivali" },
        { label: "Mocassini", href: "/uomo?cat=scarpe&sub=mocassini" },
        { label: "Derby", href: "/uomo?cat=scarpe&sub=derby" },
        { label: "Sandali", href: "/uomo?cat=scarpe&sub=sandali" },
      ],
    },
    {
      title: "Borse",
      href: "/uomo?cat=borse",
      items: [
        { label: "Borse", href: "/uomo?cat=borse&sub=borse" },
        { label: "Zaini", href: "/uomo?cat=borse&sub=zaini" },
        { label: "Porta documenti", href: "/uomo?cat=borse&sub=porta-documenti" },
        { label: "Borse da viaggio", href: "/uomo?cat=borse&sub=viaggio" },
        { label: "Borselli", href: "/uomo?cat=borse&sub=borselli" },
      ],
    },
    {
      title: "Accessori",
      href: "/uomo?cat=accessori",
      items: [
        { label: "Cinture", href: "/uomo?cat=accessori&sub=cinture" },
        { label: "Occhiali", href: "/uomo?cat=accessori&sub=occhiali" },
        { label: "Cappelli", href: "/uomo?cat=accessori&sub=cappelli" },
        { label: "Portafogli", href: "/uomo?cat=accessori&sub=portafogli" },
        { label: "Cravatte", href: "/uomo?cat=accessori&sub=cravatte" },
        { label: "Sciarpe", href: "/uomo?cat=accessori&sub=sciarpe" },
      ],
    },
    {
      title: "In evidenza",
      href: "/uomo",
      items: [
        { label: "Nuovi arrivi", href: "/uomo?view=ultimi-arrivi" },
        { label: "I più visti", href: "/uomo?view=piu-visti" },
        { label: "Saldi", href: "/uomo?view=piu-sconto" },
        { label: "Consigliati da Brupa", href: "/uomo?view=consigliati" },
      ],
    },
  ],
};

export function Navbar() {
  const { itemCount, openCart } = useCart();
  const { count: wishCount } = useWishlist();
  const [barOpen, setBarOpen] = useState(true);
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [query, setQuery] = useState("");
  const [activeMega, setActiveMega] = useState<"donna" | "uomo" | null>(null);
  const megaTimeout = useRef<ReturnType<typeof setTimeout> | null>(null);
  const navigate = useNavigate();

  function handleSearch(e?: React.FormEvent) {
    e?.preventDefault();
    if (query.trim()) {
      navigate(`/shop?q=${encodeURIComponent(query.trim())}`);
      setSearchOpen(false);
      setQuery("");
    }
  }

  function closeSearch() {
    setSearchOpen(false);
    setQuery("");
  }

  const liveResults = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (q.length < 2) return [];
    return products
      .filter(
        (p) =>
          p.name.toLowerCase().includes(q) ||
          (p.brand?.toLowerCase().includes(q) ?? false) ||
          p.category.toLowerCase().includes(q) ||
          p.description.toLowerCase().includes(q)
      )
      .slice(0, 6);
  }, [query]);

  // ESC closes search
  useEffect(() => {
    if (!searchOpen) return;
    function onKey(e: KeyboardEvent) {
      if (e.key === "Escape") closeSearch();
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [searchOpen]);

  function openMega(key: "donna" | "uomo") {
    if (megaTimeout.current) clearTimeout(megaTimeout.current);
    setActiveMega(key);
  }

  function closeMega() {
    megaTimeout.current = setTimeout(() => setActiveMega(null), 120);
  }

  function keepMega() {
    if (megaTimeout.current) clearTimeout(megaTimeout.current);
  }

  return (
    <>
      <div className="sticky top-0 z-40">
      {/* Announcement bar */}
      {barOpen && (
        <div className="bg-stone-900 text-stone-300 text-[10px] text-center py-2 tracking-[0.2em] uppercase relative flex items-center justify-center px-10">
          <span className="hidden sm:inline">Spedizione gratuita per ordini da €150 &nbsp;·&nbsp; Reso entro 14 giorni</span>
          <span className="sm:hidden">Spedizione gratis da €150 &nbsp;·&nbsp; Reso 14gg</span>
          <button
            onClick={() => setBarOpen(false)}
            aria-label="Chiudi"
            className="absolute right-4 top-1/2 -translate-y-1/2 text-stone-500 hover:text-white transition-colors"
          >
            <X className="size-3" />
          </button>
        </div>
      )}

      <header className="bg-white border-b border-stone-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center h-16">

            {/* LEFT — Logo */}
            <div className="flex-1 flex items-center">
              <NavLink to="/" onClick={() => setActiveMega(null)}>
                <BrupaLogo height={32} />
              </NavLink>
            </div>

            {/* CENTER — Nav links (desktop) */}
            <nav className="hidden md:flex items-center gap-10">
              {(["donna", "uomo"] as const).map((key) => (
                <div
                  key={key}
                  className="relative"
                  onMouseEnter={() => openMega(key)}
                  onMouseLeave={closeMega}
                >
                  <NavLink
                    to={`/${key}`}
                    onClick={() => setActiveMega(null)}
                    className={({ isActive }) =>
                      cn(
                        "flex items-center gap-1 text-xs tracking-widest uppercase font-medium transition-colors border-b border-transparent pb-0.5",
                        isActive || activeMega === key
                          ? "text-stone-900 border-stone-900"
                          : "text-stone-500 hover:text-emerald-600 hover:border-emerald-500"
                      )
                    }
                  >
                    {key.charAt(0).toUpperCase() + key.slice(1)}
                    <ChevronDown className={cn("size-3 transition-transform duration-200", activeMega === key && "rotate-180")} />
                  </NavLink>
                </div>
              ))}
              <NavLink
                to="/shop?badge=SALE"
                className={({ isActive }) =>
                  cn(
                    "text-xs tracking-widest uppercase font-medium transition-colors border-b border-transparent pb-0.5",
                    isActive
                      ? "text-red-600 border-red-600"
                      : "text-red-500 hover:text-red-700 hover:border-red-400"
                  )
                }
              >
                Saldi
              </NavLink>
              <NavLink
                to="/about"
                className={({ isActive }) =>
                  cn(
                    "text-xs tracking-widest uppercase font-medium transition-colors border-b border-transparent pb-0.5",
                    isActive
                      ? "text-stone-900 border-stone-900"
                      : "text-stone-500 hover:text-emerald-600 hover:border-emerald-500"
                  )
                }
              >
                Chi siamo
              </NavLink>
            </nav>

            {/* RIGHT — Icons */}
            <div className="flex-1 flex items-center justify-end gap-1">
              {/* Search */}
              <button
                onClick={() => setSearchOpen(!searchOpen)}
                className={cn(
                  "p-2 transition-colors",
                  searchOpen ? "text-stone-900" : "text-stone-500 hover:text-emerald-600"
                )}
                aria-label="Cerca"
              >
                <Search className="size-4" />
              </button>

              {/* Wishlist */}
              <NavLink
                to="/wishlist"
                className="relative p-2 text-stone-500 hover:text-emerald-600 transition-colors"
                aria-label="Preferiti"
              >
                <Heart className="size-4" />
                {wishCount > 0 && (
                  <span className="absolute top-0.5 right-0.5 bg-stone-900 text-white text-[9px] font-bold rounded-full size-3.5 flex items-center justify-center leading-none">
                    {wishCount > 9 ? "9+" : wishCount}
                  </span>
                )}
              </NavLink>

              {/* Cart — opens drawer */}
              <button
                onClick={openCart}
                className="relative p-2 text-stone-500 hover:text-emerald-600 transition-colors"
                aria-label="Carrello"
              >
                <ShoppingBag className="size-5" />
                {itemCount > 0 && (
                  <span className="absolute top-0.5 right-0.5 bg-stone-900 text-white text-[9px] font-bold rounded-full size-3.5 flex items-center justify-center leading-none">
                    {itemCount > 9 ? "9+" : itemCount}
                  </span>
                )}
              </button>

              {/* Admin (discrete) */}
              <NavLink
                to="/admin"
                className="p-2 text-stone-300 hover:text-emerald-600 transition-colors"
                aria-label="Admin"
                title="Pannello admin"
              >
                <Settings2 className="size-3.5" />
              </NavLink>

              {/* Mobile hamburger */}
              <button
                className="md:hidden p-2 text-stone-500 hover:text-emerald-600 transition-colors"
                onClick={() => setMenuOpen(!menuOpen)}
                aria-label="Menu"
              >
                {menuOpen ? <X className="size-5" /> : <Menu className="size-5" />}
              </button>
            </div>
          </div>

          {/* Mobile drawer */}
          {menuOpen && (
            <nav className="md:hidden border-t border-stone-100 py-5 flex flex-col gap-4">
              {[
                { to: "/donna", label: "Donna" },
                { to: "/uomo", label: "Uomo" },
                { to: "/shop?badge=SALE", label: "Saldi" },
                { to: "/about", label: "Chi siamo" },
              ].map((link) => (
                <NavLink
                  key={link.to}
                  to={link.to}
                  onClick={() => setMenuOpen(false)}
                  className="text-xs tracking-widest uppercase text-stone-600 hover:text-emerald-600 transition-colors px-2"
                >
                  {link.label}
                </NavLink>
              ))}
              <NavLink
                to="/admin"
                onClick={() => setMenuOpen(false)}
                className="text-xs tracking-widest uppercase text-stone-400 hover:text-emerald-600 transition-colors px-2 pt-3 border-t border-stone-100 flex items-center gap-2"
              >
                <Settings2 className="size-3.5" /> Admin
              </NavLink>
            </nav>
          )}
        </div>

        {/* Mega menu panel */}
        {activeMega && (
          <div
            className="absolute left-0 right-0 bg-white border-t border-stone-100 shadow-xl z-50"
            onMouseEnter={keepMega}
            onMouseLeave={closeMega}
          >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
              <div className="grid grid-cols-5 gap-6">
                {megaMenuData[activeMega].map((col) => (
                  <div key={col.title}>
                    <NavLink
                      to={col.href}
                      onClick={() => setActiveMega(null)}
                      className="block text-[10px] tracking-[0.3em] uppercase font-semibold text-stone-900 mb-4 hover:text-emerald-600 transition-colors"
                    >
                      {col.title}
                    </NavLink>
                    <ul className="space-y-2.5">
                      {col.items.map((item) => (
                        <li key={item.label}>
                          <NavLink
                            to={item.href}
                            onClick={() => setActiveMega(null)}
                            className="text-sm text-stone-500 hover:text-emerald-600 transition-colors tracking-wide"
                          >
                            {item.label}
                          </NavLink>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>

              {/* Bottom bar */}
              <div className="mt-8 pt-5 border-t border-stone-100 flex items-center gap-6">
                <span className="text-[10px] tracking-[0.3em] uppercase text-stone-400">
                  In primo piano
                </span>
                {["Nuovi arrivi", "Saldi", "Più venduti"].map((tag) => (
                  <NavLink
                    key={tag}
                    to={`/${activeMega}`}
                    onClick={() => setActiveMega(null)}
                    className="text-[10px] tracking-widest uppercase border border-stone-200 px-4 py-1.5 text-stone-600 hover:border-emerald-500 hover:text-emerald-600 transition-colors"
                  >
                    {tag}
                  </NavLink>
                ))}
              </div>
            </div>
          </div>
        )}
      </header>
      </div>

      {/* Search panel — overlay below navbar */}
      {searchOpen && (
        <>
          <div
            className="fixed inset-0 bg-stone-900/30 backdrop-blur-sm z-30"
            onClick={closeSearch}
          />
          <div className="fixed left-0 right-0 top-[64px] bg-white border-b border-stone-100 shadow-lg z-40 max-h-[calc(100vh-64px)] overflow-y-auto">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5">
              <form onSubmit={handleSearch} className="flex items-center gap-3 border-b border-stone-200 pb-3">
                <Search className="size-4 text-stone-400 flex-shrink-0" />
                <input
                  autoFocus
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  placeholder="Cerca per nome, brand, categoria..."
                  className="flex-1 text-sm bg-transparent focus:outline-none placeholder-stone-300 py-2"
                />
                {query && (
                  <button
                    type="button"
                    onClick={() => setQuery("")}
                    className="text-stone-300 hover:text-stone-600 transition-colors"
                  >
                    <X className="size-4" />
                  </button>
                )}
                <button
                  type="button"
                  onClick={closeSearch}
                  className="text-[10px] tracking-widest uppercase text-stone-400 hover:text-stone-900 transition-colors hidden sm:block"
                >
                  Chiudi
                </button>
              </form>

              {/* Live results */}
              {query.trim().length >= 2 ? (
                liveResults.length > 0 ? (
                  <div className="mt-4">
                    <p className="text-[10px] tracking-widest uppercase text-stone-400 mb-3">
                      Prodotti suggeriti
                    </p>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-1">
                      {liveResults.map((p) => (
                        <NavLink
                          key={p.id}
                          to={`/product/${p.id}`}
                          onClick={closeSearch}
                          className="flex gap-3 p-2 hover:bg-stone-50 transition-colors group"
                        >
                          <img
                            src={p.image}
                            alt={p.name}
                            className="w-12 h-16 object-cover bg-stone-100 flex-shrink-0"
                          />
                          <div className="flex-1 min-w-0">
                            <p className="text-[9px] tracking-widest uppercase text-stone-400">
                              {p.brand ?? p.category}
                            </p>
                            <p className="text-sm text-stone-800 truncate group-hover:text-stone-900">
                              {p.name}
                            </p>
                            <p className="text-xs text-stone-600 mt-0.5">
                              €{p.price.toLocaleString("it-IT")}
                              {p.originalPrice && (
                                <span className="text-stone-300 line-through ml-2">
                                  €{p.originalPrice.toLocaleString("it-IT")}
                                </span>
                              )}
                            </p>
                          </div>
                        </NavLink>
                      ))}
                    </div>
                    <button
                      type="button"
                      onClick={() => handleSearch()}
                      className="block w-full text-center mt-3 pt-3 border-t border-stone-100 text-[10px] tracking-widest uppercase text-emerald-600 hover:text-emerald-700 transition-colors py-2"
                    >
                      Vedi tutti i risultati per "{query}" →
                    </button>
                  </div>
                ) : (
                  <p className="text-sm text-stone-400 py-6 text-center">
                    Nessun prodotto trovato per "{query}"
                  </p>
                )
              ) : (
                <div className="mt-4">
                  <p className="text-[10px] tracking-widest uppercase text-stone-400 mb-3">
                    Suggerimenti rapidi
                  </p>
                  <div className="flex flex-wrap gap-2">
                    {["Herno", "Diesel", "Boss", "Dondup", "Eleventy", "Saldi"].map((tag) => (
                      <button
                        key={tag}
                        type="button"
                        onClick={() => {
                          if (tag === "Saldi") {
                            navigate("/shop?badge=SALE");
                          } else {
                            navigate(`/shop?brand=${encodeURIComponent(tag)}`);
                          }
                          closeSearch();
                        }}
                        className="text-[10px] tracking-widest uppercase border border-stone-200 px-3 py-1.5 text-stone-600 hover:border-emerald-500 hover:text-emerald-600 transition-colors"
                      >
                        {tag}
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </>
      )}

      {/* Cart drawer — always mounted, controlled by cartOpen */}
      <CartDrawer />
    </>
  );
}
